
import {
  Truck,
  Users,
  Award,
  Clock,
  Phone,
  Mail,
  MapPin,
  Shield,
  Heart,
  CheckCircle,
  Star,
  Target
} from 'lucide-react';




function DespreNoi() {
    
  const values = [
    {
      icon: <Shield className="w-8 h-8" />,
      title: "Siguranță",
      description: "Transportul sigur al mărfurilor dumneavoastră este prioritatea noastră numărul unu."
    },
    {
      icon: <Clock className="w-8 h-8" />,
      title: "Punctualitate",
      description: "Respectăm întotdeauna termenele stabilite și livrăm la timp."
    },
    {
      icon: <Heart className="w-8 h-8" />,
      title: "Dedicație",
      description: "Suntem dedicați să oferim cele mai bune servicii de transport pentru clienții noștri."
    },
    {
      icon: <CheckCircle className="w-8 h-8" />,
      title: "Calitate",
      description: "Calitatea serviciilor noastre este garantată prin echipamente moderne și personal calificat."
    }
  ];

  const stats = [
    { number: "2024", label: "Anul înființării", icon: <Award className="w-6 h-6" /> },
    { number: "300+", label: "Clienți mulțumiți", icon: <Users className="w-6 h-6" /> },
    { number: "1500+", label: "Transporturi realizate", icon: <Truck className="w-6 h-6" /> },
    { number: "24/7", label: "Disponibilitate", icon: <Clock className="w-6 h-6" /> }
  ];

  const services = [
    "Transport marfă națională și internațională",
    "Servicii de logistică și depozitare",
    "Transport special pentru mărfuri fragile",
    "Consultanță în domeniul transporturilor",
    "Soluții personalizate pentru fiecare client",
    "Urmărire în timp real a expedițiilor"
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50 overflow-x-hidden">
      
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-200/20 rounded-full blur-3xl"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-teal-200/20 rounded-full blur-3xl"></div>
      </div>

    

  
    


      {/* Main Content */}
      <div className="container mx-auto px-6 py-12">
        
        {/* Povestea noastră */}
        <div className="bg-white rounded-3xl shadow-xl p-8 mb-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-3xl font-bold text-gray-800 mb-6">Povestea Noastră</h2>
              <div className="text-gray-700 leading-relaxed space-y-4">
                <p>
                  <strong>VGL Trans Express</strong> a fost înființată în 2024 cu o viziune clară: să devenim 
                  liderul în domeniul transporturilor din România, oferind servicii de cea mai înaltă calitate.
                </p>
                <p>
                  Compania noastră, <strong>VGL Trans Express</strong>, cu sediul în județul Cluj, 
                  municipiul Dej, pe strada Valcele nr. 38A, s-a dezvoltat rapid datorită angajamentului 
                  constant față de excelență și satisfacția clienților.
                </p>
                <p>
                  De la transporturi locale la servicii internaționale, am reușit să ne extindem 
                  activitatea și să câștigăm încrederea a sute de clienți mulțumiți.
                </p>
              </div>
            </div>
            <div className="bg-gradient-to-br from-blue-50 to-teal-50 rounded-2xl p-8 text-center">
              <Truck className="w-24 h-24 text-blue-500 mx-auto mb-4" />
              <h3 className="text-2xl font-bold text-gray-800 mb-2">Misiunea Noastră</h3>
              <p className="text-gray-600">
                Să conectăm oamenii și businessurile prin servicii de transport sigure, 
                eficiente și de încredere, contribuind la dezvoltarea economiei naționale.
              </p>
            </div>
          </div>
        </div>

        {/* Statistici */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-12">
          {stats.map((stat, index) => (
            <div key={index} className="bg-white rounded-2xl shadow-lg p-6 text-center">
              <div className="text-blue-500 mb-3 flex justify-center">
                {stat.icon}
              </div>
              <div className="text-3xl font-bold text-gray-800 mb-2">{stat.number}</div>
              <div className="text-gray-600">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Valorile noastre */}
        <div className="bg-white rounded-3xl shadow-xl p-8 mb-12">
          <h2 className="text-3xl font-bold text-gray-800 text-center mb-8">Valorile Noastre</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => (
              <div key={index} className="text-center group">
                <div className="bg-gradient-to-r from-blue-500 to-teal-500 rounded-2xl p-4 w-16 h-16 mx-auto mb-4 flex items-center justify-center text-white group-hover:scale-110 transition-transform duration-300">
                  {value.icon}
                </div>
                <h3 className="text-xl font-bold text-gray-800 mb-2">{value.title}</h3>
                <p className="text-gray-600">{value.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Serviciile noastre */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <div className="bg-white rounded-3xl shadow-xl p-8">
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Serviciile Noastre</h2>
            <div className="space-y-4">
              {services.map((service, index) => (
                <div key={index} className="flex items-start">
                  <CheckCircle className="w-6 h-6 text-green-500 mr-3 mt-1 flex-shrink-0" />
                  <span className="text-gray-700">{service}</span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-gradient-to-br from-blue-500 to-teal-500 rounded-3xl shadow-xl p-8 text-white">
            <Target className="w-12 h-12 mb-6" />
            <h2 className="text-3xl font-bold mb-6">Viziunea Noastră</h2>
            <p className="text-lg leading-relaxed mb-6">
              Să fim recunoscuți ca cea mai de încredere companie de transport din România, 
              care pune clientul pe primul loc și contribuie la dezvoltarea durabilă a comunității.
            </p>
            <div className="flex items-center">
              <Star className="w-6 h-6 mr-2" />
              <span className="font-semibold">Excelența în fiecare transport</span>
            </div>
          </div>
        </div>

        {/* Date de contact și informații legale */}
        <div className="bg-white rounded-3xl shadow-xl p-8">
          <h2 className="text-3xl font-bold text-gray-800 text-center mb-8">Informații Legale</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            <div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Date de Contact</h3>
              <div className="space-y-3">
                <div className="flex items-center">
                  <Phone className="w-5 h-5 text-blue-500 mr-3" />
                  <span className="text-gray-700">+40745 586 183</span>
                </div>
                <div className="flex items-center">
                  <Mail className="w-5 h-5 text-blue-500 mr-3" />
                  <span className="text-gray-700">office@vgltransexpress.com</span>
                </div>
                <div className="flex items-start">
                  <MapPin className="w-5 h-5 text-blue-500 mr-3 mt-1" />
                  <span className="text-gray-700">
                    Județul Cluj, Dej<br />
                    Str. Valcele, nr. 38A
                  </span>
                </div>
              </div>
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Informații Companie</h3>
              <div className="space-y-2 text-gray-700">
                <p><strong>Denumire:</strong> VGL Trans Express</p>
                <p><strong>Număr înregistrare:</strong> J12/2556/2024</p>
                <p><strong>Cod fiscal:</strong> 50159666</p>
                <p><strong>Anul înființării:</strong> 2024</p>
              </div>
            </div>
          </div>
        </div>

        {/* Call to Action */}
        <div className="mt-12 text-center">
          <div className="bg-gradient-to-r from-blue-500 to-teal-500 rounded-3xl p-8 text-white">
            <h3 className="text-3xl font-bold mb-4">Alegeți Partenerii Potriviți</h3>
            <p className="text-xl mb-6">
              Cu VGL Trans Express, mărfurile dumneavoastră sunt în mâini sigure.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="tel:+40745586183"
                className="bg-white text-blue-500 font-bold py-3 px-8 rounded-2xl hover:bg-gray-100 transition-colors duration-300"
              >
                Sunați Acum
              </a>
              <a
                href="mailto:office@vgltransexpress.com"
                className="bg-transparent border-2 border-white text-white font-bold py-3 px-8 rounded-2xl hover:bg-white hover:text-blue-500 transition-colors duration-300"
              >
                Trimiteți Email
              </a>
            </div>
          </div>
        </div>
      </div>

      
    </div>
  );
}

export default DespreNoi;